import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ErrorMessage } from '../interfaces/errorMessage';
import { errors } from "../share/errors";

@Injectable({
  providedIn: 'root'
})
export class ErrorManagerService {
  private errorPublisher = new Subject<ErrorMessage>();
  ERRORS = Object.freeze(errors);
  errorStream$ = this.errorPublisher.asObservable();
  lastError: ErrorMessage = null;

  constructor(
    private toastr: ToastrService
  ) {}

  getMessage(errorData: {error: string; message?: string} | string): string {
    if(typeof(errorData) === 'string') {
      return this.getMessageFromErrorCode(errorData);
    }
    else {
      if(errorData.message) {
        return errorData.message;
      }
      else {
        return this.getMessageFromErrorCode(errorData.error);
      }
    }
  }

  private getMessageFromErrorCode(errorCode: string): string {
    if(this.ERRORS[errorCode]) {
      return this.ERRORS[errorCode];
    }
    else if (Object.keys(this.ERRORS).some(key => this.ERRORS[key] === errorCode)) {
      return errorCode;
    }
    else {
      return "Unable to process your request. If this error persists please contact Help Desk.";
    }
  }

  showSuccess(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.success(message, title, {
      ...override,
    });
  }

  showError(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.lastError = { message, title };
    this.publishError(this.lastError);
    this.toastr.error(message, title, {
      closeButton: true,
      disableTimeOut: true,
      tapToDismiss: false,
      ...override,
    });
  }

  private publishError(message: ErrorMessage) {
    this.errorPublisher.next(message);
  }

  clearToastrs(toastrId?: number) {
    this.toastr.clear(toastrId);
  }

  clearLastError() {
    this.lastError = null;
  }
}
